import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import YoutubeEmbed from "./shared-ui/Video/YoutubeEmbed";
import Accordion from "./shared-ui/Accordion/Accordion";
import { Button } from "react-bootstrap";

function VideoLibrary(props) {
  let videos = [
    {
      title: "Inspiring Treatment Possessions",
      subtitle: "Tammy’s Story With Chronic ITP",
      videoId: "MKPB1GUpY38",
      thumbnail: "meet-tammy-video.jpg",
      thumbnailAlt: "Play Video: Inspiring Treatment Possessions: Tammy's Story with ITP",
      categories: ["All"],
      transcript: (
        <>
          <p><strong>TAMMY:</strong> I'm Tammy and I'm a teacher in Washington state. I've had chronic immune thrombocytopenia for over 15 years now. Today I am showing you my inspiring treatment possessions.</p>

          <p>I'm usually a pretty active person, but when I was first diagnosed, I was pretty worn out so my remote became my friend. I couldn't even sit and read a book sometimes. It was just too tiring. So, grab the kids, grab the remote, put on a TV show or movie and off we go.</p>

          <p>It can be difficult in the beginning when being diagnosed with chronic ITP, most people don't know how they got it, so it can be a little scary that way.</p>

          <p>After being diagnosed with ITP I couldn't do my normal activities anymore so I got out my crocheting again, which I had forgotten how much I love to do. It was nice and calming. It made me feel like I was active again, even though I really wasn't moving around much.</p>

          <p>I brought this mug with the hot chocolate in it, because it really reminds me of a time when my plans had to be tentative. I had a lot of low energy due to my ITP. I couldn't always follow through with activities that I had planned. My friends all knew that, but sometimes I could have them over and we could sit around and chat and have some hot chocolate together.</p>

          <p>Over the years I had a lot of different treatments. IVIG, steroids, immunosuppressants, and some others. Some of those treatments did help, but just not well enough. There was still a lot of uncertainty. My platelet counts were all over the place and I had some bad reactions as well.</p>

          <p>What's next? Well, it’s Doptelet. After more than a decade of struggling with my chronic ITP, I finally found the right treatment for me. For those that don't know, Doptelet helps treat low blood platelets in adults with chronic ITP when other treatments haven't worked well enough.</p>

          <p>I brought this golf ball along because, like I said, I really like to be active. Can't play softball anymore. So, I traded it in for a golf ball. This is just one of the many ways I'm able to stay active on Doptelet. Because my platelets are in their target range now, I can be out all day and not have to worry about scheduling around my doctor's appointments or treatment injections.</p>

          <p>Another possession I have are my hiking boots. I really like being active and being out in nature, and when I'm out hiking, I get hungry. I usually take a lot of snacks with me. Now that I'm on Doptelet, there are no food restrictions that I have to worry about.</p>

          <p>This next item is my passport. It's great that I can take my Doptelet wherever I am. That means I can go away on a spontaneous weekend or even a longer trip abroad. Now that my platelet counts are within my target range, I don't need to monitor them as much as I used to.</p>

          <p>My treatment journey with ITP has had a lot of ups and downs. I think I tried just about everything available to me. With all that uncertainty, it was really hard to live my life the way I really wanted to. I do still have some limitations, but my platelet counts are more predictable, which gives me the opportunity to do the things I love again. That is why I'm thankful I found Doptelet.</p>

          <p>It’s just so special looking back on everything. These are all my inspiring treatment possessions. I hope you enjoyed it as much as I have.</p>

          <p><strong>VO:</strong> Serious side effects, including blood clots, may occur. Tell your doctor about any swelling, pain or leg tenderness. Fast heartbeat, shortness of breath, chest or stomach pains or tenderness. Common side effects include headache, joint pain, fatigue, bleeding gums, bruising, petechiae, nosebleed, upper respiratory infection, and runny nose. Tell your doctor if you are breastfeeding, pregnant, or planning to be.</p>

        </>
      ),
    },
    {
      title: "Inspiring Treatment Possessions",
      subtitle: "Chuck’s Story With Chronic ITP",
      videoId: "9faUORLlHGU",
      thumbnail: "meet-chuck-video.jpg",
      thumbnailAlt: "Play Video: Inspiring Treatment Possessions: Chuck's Story with ITP",
      categories: ["All"],
      transcript: (
        <>
          <p><strong>CHUCK:</strong> Hi, I’m Chuck. I’m a transportation consultant from North Carolina. I’ve had chronic immune thrombocytopenia for more than 40 years. Today, I’m here to show you my inspiring treatment possessions.</p>

          <p>Chronic ITP resulted in bruising and bleeding and made me a lot less active than I wanted to be. This radio kept me connected to all the sports and news and music that I needed.</p>

          <p>Even though I couldn’t play sports all the time, I could certainly talk about them. That microphone represents all the times that I was able to do commentating and announcing. Maybe you’ve heard my voice on big time college wrestling.</p>

          <p>When I finally got a diagnosis, it was definitely bittersweet. It was great knowing what was wrong and having some kind of an explanation for all that I’d lived with for so many years.</p>

          <p>I’ve always liked all kinds of music. I brought this CD as a reminder—in times of uncertainty when you need an emotional boost, music was a great emotional boost for me.</p>

          <p>Music is such a part of my life. Might be showtunes, might be bossa nova, might be classic rock, might be a little bit of all three. I’m just saying, any of you bands out there looking for a new frontman, call me.</p>

          <p>To treat my chronic ITP the doctors tried steroids. We tried immunosuppressants. I didn’t like the way they worked for me, and they didn’t get my platelets into my target range.</p>

          <p>My whole life I’ve been a voracious reader. Brought this book to represent the fact that when I’m going through symptoms, it was always an opportunity to find a story to, to occupy my mind. I was fortunate enough to find a great doctor who had new ideas about treatments. For me, this just reminds me that that was very important. You can never run out of books.</p>

          <p>I dealt with treatments that weren’t quite effective enough. Before finally, the right doctor said I have an alternative. It’s called Doptelet. He told me that Doptelet was a treatment for adults with chronic ITP when other treatments haven’t worked well enough. Well, that sounded great to me.</p>

          <p>One of my newer passions is riding an e-bike. I brought this bike helmet as a reminder of how happy I am to be back on the bike. When my platelet counts were too low, couldn’t ride as much as I wanted to, if at all. With my platelet count now in my target range, I get on that e-bike as often as I can.</p>

          <p>Anyone who knows me knows that food is kind of important. I will describe where I went on a trip by what I had to eat and describing the restaurants.</p>

          <p>This plate of food right now represents the fact that I’m thankful that I don’t have too many treatment restrictions with Doptelet. I can eat what I want. I can eat when I want. And because it’s a pill, I don’t have to see a doctor for any treatment injections. So not having food restrictions while taking Doptelet is an important thing for me.</p>

          <p>I brought this joke book to tell you how much I like making people happy and making people laugh. If I can reach just one person and help them feel less alone, that’ll be more than worth it for me.</p>

          <p>It’s been a long journey with chronic ITP. I’m so glad that I found the doctor I did find, but I wish I’d found that doctor sooner. I still have some limitations, but now that my platelets are within my target range I don’t have to monitor as often—which gives me the opportunity to do more of the things that I want to do.</p>

          <p>I know I’ve enjoyed sharing my inspiring treatment possessions. I really hope it’s meant as much to you as it has to me.</p>

          <p><strong>VO:</strong> Serious side effects, including blood clots, may occur. Tell your doctor about any swelling, pain or leg tenderness. Fast heartbeat, shortness of breath, chest or stomach pains or tenderness. Common side effects include headache, joint pain, fatigue, bleeding gums, bruising, petechiae, nosebleed, upper respiratory infection, and runny nose. Tell your doctor if you are breastfeeding, pregnant, or planning to be.</p>
        </>
      ),
    },
    {
      title: "Inspiring Treatment Possessions",
      subtitle: "Chuck & Tammy’s Stories With Chronic ITP",
      videoId: "V8j9_w6w_Qo",
      thumbnail: "chuck-and-tammy.jpg",
      thumbnailAlt: "Play Video: Dopteller Diaries: Life After Diagnosis",
      categories: ["All", "DOPTELLERS"],
      transcript: (
        <>
          <p><strong>TAMMY:</strong> 	Hi, I’m Tammy and I’ve had chronic immune thrombocytopenia for over 15 years now.</p>

          <p>
            <strong>CHUCK:</strong>	And I’m Chuck, and I know it’s not a contest, but I’ve had it for 40 years. Tammy, you know what I brought today?
          </p>
          <p>
            <strong>TAMMY:</strong>	What?
          </p>
          <p>
            <strong>CHUCK:</strong>	Inspiring treatment possessions!
          </p>

          <p><strong>TAMMY:</strong>	I brought some, too. </p>

          <p><strong>CHUCK:</strong>	Really? I want to know about your symptoms, your diagnosis, and your treatment and see how they’re the same.</p>

          <p><strong>TAMMY:</strong>	I want to hear about yours, too. And also, then see how they’re different. </p>

          <p><strong>CHUCK:</strong>	That would be cool. Yeah. Before I found a chronic ITP treatment that worked for me, I had to give up my e-bike.</p>

          <p><strong>TAMMY:</strong>	Yeah, I understand, I used to ride a bike and a motorcycle too, but when my counts got really low, it was just not safe for me to be on the motorcycle anymore.</p>

          <p><strong>CHUCK:</strong>	Before I found out my counts were so low, I’d do 40 or 50 miles a day. I got to the point where I was too worried, and I didn’t ride any bike at all. </p>

          <p><strong>TAMMY:</strong>	My item isn’t as much fun as yours, but it’s headphones. When I was first diagnosed, I just couldn’t do a whole lot. You get so tired that it’s really hard to do much of anything else but sit around. So, I would binge-watch movies and TV shows and things like that. But if I got tired of that, I would just throw on my headphones and listen to an audiobook. </p>

          <p><strong>CHUCK:</strong>	Sometimes when your counts are low, that’s about all you can do. </p>

          <p><strong>TAMMY:</strong>	It’s really frustrating. Especially because I really like being active. I’m not one to just sit around and do nothing. And what was your diagnosis experience like? </p>

          <p><strong>CHUCK:</strong>	It was a long time ago, back when my fanny pack was still popular. I’d had some bruising. I’d had some bleeding gums. Went in for a blood test for a minor surgical procedure, and they told me my platelets were low, and it turned out to be chronic ITP because it didn’t go away on its own. So how about you? </p>

          <p><strong>TAMMY:</strong>	Well, this deck of cards represents my diagnosis. When I was a kid, we used to play cards a lot. So family is really important to me. And they were around really to support me throughout a lot of this.</p>

          <p>When I had my son. My platelets stayed the same. And then when I had my daughter, my platelets dropped. So, they were like, well, what’s going on here? Many years later, I had to have a hysterectomy and had to have a blood transfusion due to some complications. My body then decided to just destroy all of my platelets. And then my family actually came into town. The support from them really helped me a lot. That’s what this deck of cards represents. So, that’s what led me into having chronic ITP. </p>

          <p><strong>CHUCK:</strong> 	Holy cow. What happened next? </p>

          <p><strong>TAMMY:</strong>	Well, that leads me into my next items. </p>

          <p><strong>CHUCK:</strong>	What is all this? </p>

          <p><strong>TAMMY:</strong>	Umm, that’s uh, just a bunch of stuff. Kind of represents all the treatment options I’ve been on. Steroids, immunosuppressants, IVIG—they just didn’t quite keep my counts up. </p>

          <p><strong>CHUCK:</strong>	Yeah, I tried steroids years ago. And it just, it didn’t work for me. It didn’t work well enough. Man, I hated the way I felt.</p>

          <p><strong>TAMMY:</strong>	So, since the steroids weren’t working for me, I tried some other options. There are a couple pills that I tried over the years that caused me to not be able to eat when I really necessarily wanted to, or would give food restrictions of some kind. Then I went on to an injection, and that one just stopped working for me too.</p>

          <p><strong>CHUCK:</strong>	I had no idea there were that many options, you know? But I get the ups and downs. You know what I mean? My next item is a washer.</p>

          <p><strong>TAMMY:</strong>	A tiny little washer?</p>

          <p><strong>CHUCK:</strong>	A tiny little washer. Doctor found a spot about the size of this washer, maybe just a little smaller, on my lung. Needed to have surgery to get it checked out, removed. But my platelet count was too low. We tried the steroids again and the immunosuppressants, and we were absolutely convinced, my doctor and I, that we needed a long-term treatment. I should have been working together closer with my doctor for a long time. Back when I was wearing this. </p>

          <p><strong>TAMMY:</strong>	Yep. Yeah, I got really lucky. I have a chronic ITP specialist in the area. We tried a lot early on, but if it wasn’t for continued research, going to the PDSA meetings, and talking to her, I wouldn’t have found Doptelet to treat my low blood platelet count when those other treatments just weren’t working well enough. Really is helpful to have that two-way communication with your doctor, talking about different options, different treatments and side effects that come along with the medications. So, when we talked about Doptelet, I found out that there were no food restrictions, which was really, really helpful. I could just eat what I wanted when I wanted to, just as long as I was taking it at a steady certain time of day. </p>

          <p><strong>CHUCK:</strong>	That’d be really important to me too. I do like to eat. </p>

          <p><strong>TAMMY:</strong>	So, this is my next item. Remember how I said I couldn’t ride the motorcycle anymore? But now with Doptelet, my platelet counts have been in a target range for a few years now. So, now I can go off roading. </p>

          <p><strong>CHUCK:</strong>	That rules. </p>

          <p><strong>TAMMY:</strong>	It’s really nice because even if I’m out driving with my husband and we get stuck somewhere. I still have my medication, and I can take it when I need to. </p>

          <p><strong>CHUCK:</strong>	It really is about having good people in your corner, isn’t it? Let’s do the last one together. </p>

          <p><strong>TAMMY:</strong>	That sounds like fun!</p>

          <p><strong>CHUCK:</strong>	Of course, we both brought photos. </p>

          <p><strong>TAMMY:</strong>	This is what it’s all about for me. Friends, family, coworkers. Ever since Doptelet was able to keep me in my goal range, it’s just been an incredible feeling. And it’s been great to be able to share it with all of them. </p>

          <p><strong>CHUCK:</strong>	That’s really sweet, and I get it. These are the folks who taught me about what community means. My community now includes my doctor. And since my doctor introduced me to Doptelet, there have been many changes in my life. Now I’m able to do all kinds of things. In fact, I get together with my e-bike as often as I possibly can. </p>

          <p><strong>TAMMY:</strong>	So, what does the future have in store for you? </p>

          <p><strong>CHUCK:</strong>	I don’t know, but I am happy that my platelet counts within my goal range.</p>

          <p><strong>TAMMY:</strong>	You’ve got to stay positive.</p>

          <p><strong>CHUCK:</strong> 	And lifted. </p>

          <p><strong>TAMMY:</strong>	Well, thank you for watching us go through our inspiring treatment possessions. </p>

          <p><strong>CHUCK:</strong>	We hope you’ve enjoyed it as much as we have. </p>

          <p><strong>VO:</strong>	Serious side effects, including blood clots, may occur. Tell your doctor about any swelling, pain or leg tenderness. Fast heartbeat, shortness of breath, chest or stomach pains or tenderness. Common side effects include headache, joint pain, fatigue, bleeding gums, bruising, petechiae, nosebleed, upper respiratory infection, and runny nose. Tell your doctor if you are breastfeeding, pregnant, or planning to be.</p>
        </>
      ),
    },
    {
      title: "Tammy‘s Tips",
      subtitle: "A Doctor’s Guide To Exploring Treatment Options",
      videoId: "0MBBZAyO_To",
      thumbnail: "tammystips-a-doctors-guide.jpg",
      thumbnailAlt: "Play Video: A Doctor's Guide for Exploring ITP Treatment",
      categories: ["All", "Tammys Tips"],
      transcript: (
        <>
          <p>
            <strong>TAMMY:</strong> Hi, I’m Tammy and I’ve been living with low blood platelet counts in
            chronic immune thrombocytopenia for over 15 years now. I’ve learned
            a thing or two along the way and now I want to share that with you!
          </p>
          <p>
            <strong>VO:</strong> Doptelet is a prescription medicine used to treat low blood platelet
            counts in adults with chronic immune thrombocytopenia (ITP) when
            other treatments have not worked well enough.
          </p>
          <p>
            Doptelet is not used to make platelet counts normal in adults with
            chronic ITP. It is not known if Doptelet is safe and effective in
            children.
          </p>
          <p>
            <strong>TAMMY:</strong> Please welcome Dr. Leila Van Doren who’s going to share her best
            pieces of advice when it comes to exploring treatment options.
          </p>
          <p>
            <strong>HCP:</strong> Thank you for having me, Tammy. I’m Dr. Van Doren, and I have some
            advice to share with you today.
          </p>
          <p>
            First, patients should understand that not every medication will
            work for them or that some medications may work for a while and then
            stop working.
          </p>
          <p>
            The best thing you can do is talk to your doctor if you’re
            dissatisfied with treatment, whatever your reason may be…
          </p>
          <p>
            <strong>TAMMY:</strong> Definitely, I agree, Dr. Van Doren. When I was concerned about my
            platelet counts, my doctor encouraged me to be as honest as possible
            because there are many treatments out there, but if you don’t speak
            up, you might not get the chance to find that right fit.
          </p>
          <p>
            <strong>HCP:</strong> That’s good advice, as a medical doctor, I also feel the need to
            express that every patient has a unique platelet count and,
            therefore, treatment experience.
          </p>
          <p>Keep in mind every treatment has potential side effects.</p>
          <p>
            Voicing your concerns and being open with your doctor can lead to a
            shared decision that both of you feel comfortable with.
          </p>
          <p><strong>TAMMY:</strong> My doctor said the same thing.</p>
          <p><strong>HCP:</strong> We’re here for you.</p>
          <p>
            And someone else is here for you too, our very own specialist,
            Safety Steve.
          </p>
          <p>
            <strong>SAFETY STEVE:</strong> Hi, I’m Steve. Safety Steve. Safety is my whoooole world. My
            favorite accessory? bandages. I don’t even have cuts on these
            fingers. Favorite summer activity? Applying sunscreen. And favorite
            part of this video? It’s right now. Because I’m about to share
            important safety information about Doptelet…
          </p>
          <p>
            Doptelet doesn’t make platelet counts normal and may cause serious
            side effects, including blood clots, which may be an increased risk
            for people with chronic ITP and certain blood-clotting conditions.
          </p>
          <p>
            <strong>HCP:</strong> Thank you, Steve! For my last tip, only you know what kind of
            treatments will fit best into your day-to-day life…and which ones
            might not.
          </p>
          <p>
            Which is why it’s important to have shared decision making between
            you and your healthcare provider.
          </p>
          <p>
            <strong>TAMMY:</strong> That is some great advice. Seeking out patient resources and
            educating myself also helped me prepare for and feel more confident
            going into discussions with my doctor.
          </p>
          <p>
            Remember to screenshot these tips for reference later. Now stay
            tuned for some important safety information.
          </p>
        </>
      ),
    },
    {
      title: "Tammy‘s Tips",
      subtitle: "Important Questions to Ask Your Doctor",
      videoId: "BuIhQABk2-A",
      thumbnail: "tammystips-important-questions-to-ask-your-doctor.jpg",
      thumbnailAlt:
        "Play Video: Important Questions to Ask Your Doctor About ITP Treatment",
      categories: ["All", "Tammys Tips"],
      transcript: (
        <>
          <p>
            <strong>TAMMY:</strong> Hi, I’m Tammy and I’ve been living with low blood platelet counts in
            chronic immune thrombocytopenia for over 15 years now. I’ve learned
            a thing or two along the way and now I want to share that with you!
          </p>
          <p>
            <strong>VO:</strong> Doptelet is a prescription medicine used to treat low blood platelet
            counts in adults with chronic immune thrombocytopenia (ITP) when
            other treatments have not worked well enough.
          </p>
          <p>
            Doptelet is not used to make platelet counts normal in adults with
            chronic ITP. It is not known if Doptelet is safe and effective in
            children.
          </p>
          <p>
            <strong>TAMMY:</strong> As someone living with low blood platelet counts in chronic ITP
            who’s asked her doctor many questions over the years, I want to
            share some helpful questions to ask your doctor about setting
            treatment goals.
          </p>
          <p>
            The first question is: What would be considered a platelet count
            goal for me?
          </p>
          <p>
            Asking my doctor about my platelet count goal helped open up a
            conversation that led me to trying Doptelet. And I was glad to see
            my platelet counts go up.
          </p>
          <p>
            But if I hadn’t talked to my doctor about wanting a treatment that
            could work for me and my needs, she may not have suggested Doptelet.
          </p>
          <p>
            Another good question to ask is: What happens if I’m on a treatment,
            but my platelet counts still aren’t where they need to be?
          </p>
          <p>
            Before I give that answer, I am going to invite in our very own safety specialist,
            Steve, to give you some important information about Doptelet.
          </p>
          <p>
            <strong>SAFETY STEVE:</strong> Hi. Steve here. I’m your resident “SAFETY GUY”. Yeah, that’s right. Safety is my
            middle name. Well no. It’s Jeffrey. But anyway. Let’s talk about some things you should know, the important safety information for Doptelet.
          </p>
          <p>
            Now, Doptelet doesn’t make platelet counts normal and may cause serious side effects,
            including blood clots, which may be an increased risk for people with chronic ITP and certain blood-clotting conditions. And we'll discuss additional safety information later in this video.
          </p>
          <p>
            <strong>TAMMY:</strong> Thank you, Steve. Now where was I? Oh yes, if you’ve watched other
            videos of me, you’ll know I’ve been on many treatments over the
            years, and what made me consider treatment with Doptelet was the
            fact that my platelet counts were frequently fluctuating.
          </p>
          <p>
            I’m glad I was honest with my doctor about my concerns, because that
            led us to finding a treatment that has raised my platelet counts and
            is keeping my count steady!
          </p>
          <p>
            Be sure to screenshot these questions to bring to your next
            appointment! And don’t forget to keep checking out Tammy’s Tips at
            www.TipsFromTammy.com
          </p>
          <p>Now, stay tuned for some important safety information.</p>
        </>
      ),
    },
    {
      title: "Tammy‘s Tips",
      subtitle: "Getting the Most Out of Your Doctor’s Appointments",
      videoId: "Pm7emPcFX08",
      thumbnail:
        "tammystips-getting-the-most-out-of-your-doctors-appointments.jpg",
      thumbnailAlt:
        "Play Video: Tips for Getting the Most Out of Your Doctor's Appointments",
      categories: ["All", "Tammys Tips"],
      transcript: (
        <>
          <p>
            <strong>TAMMY:</strong> Hi, I’m Tammy and I’ve been living with low blood platelet counts in
            chronic immune thrombocytopenia for over 15 years now. I’ve learned
            a thing or two along the way, and now I want to share that with you!
          </p>
          <p>
            <strong>VO:</strong> Doptelet is a prescription medicine used to treat low blood platelet
            counts in adults with chronic immune thrombocytopenia (ITP) when
            other treatments have not worked well enough.
          </p>
          <p>
            Doptelet is not used to make platelet counts normal in adults with
            chronic ITP. It is not known if Doptelet is safe and effective in
            children.
          </p>
          <p><strong>TAMMY:</strong> I may be biased, but this is a good one.</p>
          <p>
            Today, I’m covering my top 4 ideas for people living with low blood
            platelet counts in chronic ITP to get the most out of their doctor’s
            appointments.
          </p>
          <p>
            One: As intimidating as it is to talk or feel like you’re
            complaining to a medical professional they want what’s best for you.
            It takes teamwork to reach your treatment goals, so creating an open
            dialogue is key, and it’s important to be your own advocate.
          </p>
          <p>
            Two: Write down questions before going. For example, what, if any,
            adjustments will I have to make to my day-to-day life when I start
            treatment?
          </p>
          <p>
            <strong>HCP:</strong> Hi, hematologist here! Questions help me understand where your
            concerns lie, so I can better focus my answers and make it a more
            productive experience for both of us.
          </p>
          <p><strong>TAMMY:</strong> Yes, what she said.</p>
          <p><strong>HCP:</strong> Bye!</p>
          <p>
            Three: If you can, try to bring someone else with you because it can
            be hard to remember everything.
          </p>
          <p>
            Four: Don’t let your doctor leave until you have your answers. If
            you’re unsure of anything, like what’s happening with your
            platelets, always make sure to ask your doctor to explain, rather
            than assume you already know the answer.
          </p>
          <p>
            Listen to really understand what your doctor is saying because, in
            the end, you can’t make a shared decision without them, unless
            you’re both informed going into treatment conversations.
          </p>
          <p>
            Feel free to screenshot these tips and keep them handy. And don’t
            forget to watch other Tammy’s Tips videos at www.TipsFromTammy.com
          </p>
        </>
      ),
    },
    {
      title: "Patient Stories",
      subtitle: "Being Me",
      videoId: "_sHszTR2J8c",
      thumbnail: "dopdiaries-being-me.jpg",
      thumbnailAlt: "Play Video: Dopteller Diaries: Living with ITP",
      categories: ["All", "DOPTELLERS"],
      transcript: (
        <>
          <p>
            <strong>TAMMY:</strong> I'm Tammy and I live in Washington state and I’m a teacher and I
            have had ITP for 15 years now.{" "}
          </p>
          <p>
            I've been on many different treatment options, I've tried just about
            everything. The medications weren't helping me stay up, they would
            be up and then they would drop and then they maybe go up a little
            bit and then they'd go back down and it was this we call it a roller
            coaster because that's what it feels like you're on this roller
            coaster okay you're going up up up and then all of a sudden you're
            down.
          </p>
          <p>
            When I started on Doptelet, my doctor actually called me steady for
            my platelet count which was amazing. It hadn't happened in a long
            time because I'd been going in pretty much weekly blood draws for I
            don't know how many years now and so when she told me I was steady
            then and she said well you can go in every 3 to 4 weeks for a blood
            draw and I started kind of doing the math and 52 blood draws a year
            was what I normally had been doing and now I was down to maybe 12 to
            20 a year and that just was amazing to me because I haven't had that
            in a very long time.
          </p>
          <p>
            Over these last few years I never really thought a lot about the
            future as much because I was always going day to day or week to week
            and now with being on Doptelet I can actually think ahead, my
            husband and I are thinking retirement, you know thinking years ahead
            and it's been really nice to be able to talk about things that are
            years ahead versus just having to focus on days or weeks ahead
            because on other medications that's all I could do it was all about
            okay where am I at and do I need to go back in the hospital for
            another treatment, do I need to start looking at other options and
            it's been so nice not having to think about other options I can just
            be me.
          </p>
        </>
      ),
    },
    {
      title: "Tammy’s Tips",
      subtitle: "Things I Wish I Knew When I Was Diagnosed",
      videoId: "zKwNORop9Tw",
      thumbnail: "tammystips-things-i-wish-i-knew.jpg",
      thumbnailAlt: "Play Video: Things to Know After Chronic ITP Diagnosis",
      categories: ["All", "Tammys Tips"],
      transcript: (
        <>
          <p>
            <strong>TAMMY:</strong> Hi, I’m Tammy, and I’ve been living with low blood platelet counts
            in chronic immune thrombocytopenia for over 15 years now. I’ve
            learned a thing or two along the way, and now I want to share that
            with you!
          </p>
          <p>
            <strong>VO:</strong> Doptelet is a prescription medicine used to treat low blood platelet
            counts in adults with chronic immune thrombocytopenia (ITP) when
            other treatments have not worked well enough.
          </p>
          <p>
            Doptelet is not used to make platelet counts normal in adults with
            chronic ITP. It is not known if Doptelet is safe and effective in
            children.
          </p>
          <p>
            <strong>TAMMY:</strong> Let’s talk about the top 3 things I wish I knew when I was diagnosed
            with low platelet counts in chronic immune thrombocytopenia.{" "}
          </p>
          <p>
            First, you have a say in your treatment — if you are not happy with
            how it’s going, don’t be afraid to speak up because what works for
            other people may not work for you. You are your best advocate.{" "}
          </p>
          <p>
            Talking to my doctor helped her understand what wasn’t working for
            me and led us to explore different treatments.{" "}
          </p>
          <p>
            The second thing I wish I knew is that finding a support
            organization may be helpful. One option is the Platelet Disorder
            Support Association.
          </p>
          <p>
            And for my last tip…remember you are not alone; there is a
            supportive community and educational resources out there that you
            can turn to.
          </p>
          <p>
            Hopefully these tips help you find support and the right treatment
            fit for you. Feel free to screenshot them for your reference! Now
            stay tuned for some important safety information.
          </p>
        </>
      ),
    },
  ];
  const activePatient = props.activePatient;
  if (activePatient == "tammy") {
    videos.splice(0, 1);
  } else if (activePatient == "chuck") {
    videos.splice(1, 1);
  }
  const categories = ["All", "DOPTELLERS", "Tammys Tips"];
  const [activeVideo, setActiveVideo] = useState(videos[0]);
  const [activeCategory, setActiveCategory] = useState(categories[0]);

  const changeActiveVideo = (index) => {
    setActiveVideo(videos[index]);
    document.querySelector(".video-section:not(.dopteller-diaries)").scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const changeActiveCategory = (index) => {
    setActiveCategory(categories[index]);
  };

  return (
    <div className="video-section" data-active-patient={activePatient}>
      <Row>
        <Col sm={12} lg={7} className="mb-2 mb-lg-0">
          <div className="left-side">
            {/*<Row className="d-flex d-md-none categories pb-2 mb-2 border-bottom">
              {categories.map((category, i) => {
                return (
                  <Button
                    key={category}
                    className={
                      (category == activeCategory ? "active" : "") + " btn-sm"
                    }
                    onClick={(e) => changeActiveCategory(i, e)}>
                    {category}
                  </Button>
                );
              })}
            </Row>*/}
            <div className="video-wrapper">
              <YoutubeEmbed
                embedId={activeVideo.videoId}
                image={[activeVideo.thumbnail, activeVideo.thumbnail]}
                imageMobile={[activeVideo.thumbnail, activeVideo.thumbnail]}
                alt={activeVideo.title}
                onProgress={(e) => console.log(e.playedSeconds)}
                className={activeVideo.className}
              />
            </div>
            <Accordion className="mt-3" title="Transcript" markup={activeVideo.transcript} />
            <h4>
              <strong>{activeVideo.title}</strong>
            </h4>
            <p className="mb-0">{activeVideo.subtitle}</p>
          </div>
        </Col>
        <Col sm={12} lg={5}>
          {/*<Row className="d-none d-md-flex categories pb-2 mb-2 border-bottom">
            {categories.map((category, i) => {
              return (
                <Button
                  key={category}
                  className={
                    (category == activeCategory ? "active" : "") + " btn-sm"
                  }
                  onClick={(e) => changeActiveCategory(i, e)}>
                  {category}
                </Button>
              );
            })}
          </Row>*/}
          <div className="right-side video-list">
            <div className="scroll-container">
              {videos.map((video, i) => {
                return video.categories.includes(activeCategory) ? (
                  <Col
                    key={video.videoId}
                    className={
                      (video.videoId == activeVideo.videoId ? "active" : "") +
                      " d-flex p-2"
                    }
                    onClick={(e) => changeActiveVideo(i, e)}>
                    <Col sm={4} className="px-0 thumb">
                      <img
                        className="img-responsive"
                        src={"/images/" + video.thumbnail}
                        alt={video.thumbnailAlt}
                      />
                    </Col>
                    <Col sm={8}>
                      <h4>
                        <strong>{video.title}</strong>
                      </h4>
                      <p>{video.subtitle}</p>
                    </Col>
                  </Col>
                ) : (
                  ""
                );
              })}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
export default VideoLibrary;
